import { useAppSelector, useAppDispatch } from '@store/hooks'
import { logout } from '@store/auth/authSlice'
import { useNavigate } from 'react-router-dom'
import './Header.scss'

export const Header = () => {
  const { user } = useAppSelector(state => state.auth)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await dispatch(logout())
    navigate('/login')
  }

  return (
    <header className="crif-header">
      <div className="crif-header-container">
        <div className="crif-header-brand">
          <img src="/assets/crif-logo.svg" alt="CRIF Logo" className="crif-logo" />
          <h1 className="crif-title">AML-Guard</h1>
        </div>

        <nav className="crif-header-nav">
          <div className="crif-user-menu dropdown">
            <button
              className="btn btn-link dropdown-toggle"
              type="button"
              id="userMenuDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="bi bi-person-circle"></i>
              <span className="ms-2">
                {user?.firstName} {user?.lastName}
              </span>
            </button>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userMenuDropdown">
              <li>
                <a className="dropdown-item" href="/profile">
                  <i className="bi bi-person"></i> Profile
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="/settings">
                  <i className="bi bi-gear"></i> Settings
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <button className="dropdown-item" onClick={handleLogout}>
                  <i className="bi bi-box-arrow-right"></i> Logout
                </button>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  )
}

export default Header
